import React from 'react'
import { useEffect } from 'react'

import {
  Icon,
  RowFlexDiv,
  ColumnFlexDiv,
  UserProfilePictureHolder,
  UserProfilePicture,
} from '../Common/CommonStyle'
import OnlineStatus from '../Common/OnlineStatus'

import Notification from '../Common/Notification'

import {
  NudistaMedium14,
  NudistaMedium16,
  NudistaBold16,
  NudistaMedium12,
  RobotoMedium14,
  NudistaMedium7,
  NudistaBold12,
  NudistaSemiBold8,
} from '../Common/Fonts'
import { useHistory } from 'react-router-dom'

const week = [
  {
    day: 'SUN',
    date: '01',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
  {
    day: 'MON',
    date: '02',
    weather: '/images/mainView/assignmentsView/sun.svg',
  },
  {
    day: 'TUE',
    date: '03',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
  {
    day: 'WED',
    date: '04',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
  {
    day: 'THU',
    date: '05',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
  {
    day: 'FRI',
    date: '06',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
  {
    day: 'SAT',
    date: '07',
    weather: '/images/mainView/assignmentsView/weather-1.svg',
  },
]
const assignments = [
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '1',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '2',
  },
  {
    icon: '/images/navbar/add_2.svg',
    name: 'Holmes, Kate',
    id: '3',
  },
]

const DateDetails = ({
  calendarView = { calendarView },
  setCalendarView = { setCalendarView },
}) => {
  const [index, setIndex] = React.useState(0)

  function handleChange(event) {
    console.log('name is', event.target.name)
    const lastIndex = week.length - 1
    console.log(index)

    if (event.target.name === 'decrease') {
      if (index == 0) {
        // setIndex(0)
      } else {
        setIndex(index - 1)
      }
    } else if (event.target.name === 'increase') {
      if (index + 3 > lastIndex) {
        setIndex(0)
      } else {
        setIndex(index + 1)
      }
    }
  }

  return (
    <RowFlexDiv
      gap='15px'
      width='100%'
      position='relative'
      overflow='hidden'
      justifyContent='flex-start'
    >
      {calendarView ? (
        <RowFlexDiv
          marginLeft='-15px'
          position='fixed'
          top='0'
          marginTop='50vh'
        >
          <Icon
            width='35px'
            height='35px'
            marginLeft='1%'
            src='/images/mainView/assignmentsView/arrow-weeks-group.svg'
            name='decrease'
            onClick={handleChange}
          />
        </RowFlexDiv>
      ) : (
        <></>
      )}
      {week.map((weather, calendarIndex) => {
        return (
          <ColumnFlexDiv
            width={calendarView ? '40%' : '14.28%'}
            opacity={
              calendarView
                ? index === calendarIndex ||
                  index + 1 === calendarIndex ||
                  index + 2 === calendarIndex
                  ? '1'
                  : '0'
                : '1'
            }
            display={
              calendarView
                ? index === calendarIndex ||
                  index + 1 === calendarIndex ||
                  index + 2 === calendarIndex
                  ? 'flex'
                  : 'None'
                : 'flex'
            }
            border='1px solid rgba(106,38,202, 0.2)'
            backgroundColor={weather.day === 'MON' ? '#6A26CA' : ''}
          >
            <RowFlexDiv key={weather.id} justifyContent='flex-start' gap='5px'>
              <Icon marginLeft='5%' src={weather.weather} />
              <ColumnFlexDiv justifyContent='center' alignItems='center'>
                <NudistaMedium16
                  color={weather.day === 'MON' ? 'whiteColor' : 'primary'}
                >
                  {weather.day}
                </NudistaMedium16>
                <NudistaBold16
                  color={weather.day === 'MON' ? 'whiteColor' : 'primary'}
                >
                  {weather.date}
                </NudistaBold16>
              </ColumnFlexDiv>
            </RowFlexDiv>
            <ColumnFlexDiv gap='10px'>
              {calendarView ? (
                <>
                  <CalendarImage />
                  <CalendarImage />
                  <CalendarImage /> <CalendarImage />
                  <CalendarImage /> <CalendarImage />
                </>
              ) : (
                <>
                  <WeekImage />
                  <WeekImage />
                  <WeekImage />
                  <WeekImage />
                  <WeekImage />
                  <WeekImage />
                  {/* <WeekImage />
                  <WeekImage /> */}
                </>
              )}
            </ColumnFlexDiv>
          </ColumnFlexDiv>
        )
      })}
      {calendarView ? (
        <RowFlexDiv
          width='max-content'
          marginLeft='-25px'
          position='fixed'
          top='0'
          right='1%'
          marginTop='50vh'
        >
          <Icon
            width='35px'
            height='35px'
            marginLeft='1%'
            transform='rotate(180deg)'
            src='/images/mainView/assignmentsView/arrow-weeks-group.svg'
            name='increase'
            onClick={handleChange}
          />
        </RowFlexDiv>
      ) : (
        <></>
      )}
    </RowFlexDiv>
  )
}
const CalendarImage = () => {
  const history = useHistory()

  return (
    <RowFlexDiv
      width='96%'
      marginLeft='2%'
      height='200px'
      backgroundColor='#EEE9F3'
      alignItems='flex-start'
    >
      <RowFlexDiv height='100%' justifyContent='flex-start' gap='2px'>
        {/* <RowFlexDiv width='50%' backgroundColor='#123456' height='90%'> */}
        <Icon
          width='50%'
          height='90%'
          marginLeft='1%'
          src='/images/mainView/assignmentsView/stock_home.jpg'
          onClick={() => {
            history.push('/gallery-view')
          }}
        />
        {/* </RowFlexDiv> */}

        <ColumnFlexDiv
          width='50%'
          height='90%'
          justifyContent='space-between'
          margin='0 5px 0 5px'
          gap='4px'
        >
          <RowFlexDiv width='96%' gap='5px'>
            <RowFlexDiv>
              <Icon
                width='18px'
                height='18px'
                alignSelf='flex-start'
                src='/images//mainView/assignmentsView/company-logo@2x.png'
                alt='facebook_icon'
              />
              <NudistaSemiBold8>National General Insurance</NudistaSemiBold8>
            </RowFlexDiv>

            <Icon
              width='4px'
              opacity='0.4'
              src='/images/mainView/assignmentsView/three-dots.svg'
            />
          </RowFlexDiv>
          <RowFlexDiv height='10%' width='98%' position='relative'>
            <OnlineStatus marginLeft={'94%'} marginTop={'5%'} />
          </RowFlexDiv>

          <ColumnFlexDiv gap='5px'>
            <RowFlexDiv height='25px' width='98%' position='relative'>
              <NudistaMedium14 color='primary'>NI283929123</NudistaMedium14>
              <Notification />

              {/* <OnlineStatus marginLeft={'90%'} marginTop={'5%'} /> */}
            </RowFlexDiv>

            {/* <NudistaMedium14 color='primary'>NI283929123</NudistaMedium14> */}

            <NudistaBold16 color='Black'>Evil Corp.</NudistaBold16>
            <RowFlexDiv width='70%'>
              <NudistaMedium12 color='primary'>
                525 NE North Ave, Atlanta, GA 30308
              </NudistaMedium12>
            </RowFlexDiv>
            <RowFlexDiv
              width='70%'
              height='38px'
              justifyContent='flex-start'
              marginLeft='4px'
            >
              {assignments?.map((value, id) => (
                <UserProfilePictureHolder
                  width='35px'
                  height='35px'
                  marginLeft='-5px'
                  key={value.id}
                >
                  <UserProfilePicture
                    width='40px'
                    alt='Holmes, Kate'
                    src={value.icon}
                  />
                </UserProfilePictureHolder>
              ))}
            </RowFlexDiv>
          </ColumnFlexDiv>
        </ColumnFlexDiv>
      </RowFlexDiv>
    </RowFlexDiv>
  )
}

const WeekImage = () => {
  const history = useHistory()

  return (
    <RowFlexDiv
      margin='0 5px 0 5px'
      height='170.81px'
      backgroundColor='#EEE9F3'
      alignItems='flex-start'
      overflow='hidden'
    >
      <ColumnFlexDiv gap='10px' position='relative'>
        <Icon
          width='100%'
          height='75px'
          src='/images/mainView/assignmentsView/stock_home.jpg'
          onClick={() => {
            history.push('/gallery-view')
          }}
        />
        <RowFlexDiv height='100%' width='95%' position='relative'>
          <OnlineStatus marginLeft={'94%'} marginTop={'-99%'} />
        </RowFlexDiv>

        <RowFlexDiv
          width='65px'
          height='20px'
          backgroundColor='#250F43'
          position='absolute'
          justifyContent='center'
          zIndex='9111'
        >
          <NudistaMedium14 white>09:30AM</NudistaMedium14>
        </RowFlexDiv>

        <ColumnFlexDiv margin='0 5px 0 5px' gap='4px'>
          <RowFlexDiv>
            <NudistaMedium14 color='primary'>NI283929123</NudistaMedium14>
            <Icon
              opacity='0.7'
              width='4px'
              src='/images/mainView/assignmentsView/three-dots.svg'
            />
          </RowFlexDiv>
          <NudistaBold16 color='Black'>Corp.</NudistaBold16>
          <NudistaMedium12 color='primary'>
            525 NE North Ave, Atlanta, GA 30308
          </NudistaMedium12>
        </ColumnFlexDiv>
      </ColumnFlexDiv>
    </RowFlexDiv>
  )
}
export default DateDetails
